A subscription for a given event type and scheme to be delivered via webhook.

Events are delivered in batches with a HTTP POST request to the specified subscription URL.
